import { render, staticRenderFns } from "./ContractorPayslips.vue?vue&type=template&id=22e28406"
import script from "./ContractorPayslips.vue?vue&type=script&lang=js"
export * from "./ContractorPayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports